var base = require('client_core/product/base');

// Wrap numbers in product names with a span with class 'number' in order to get them to be the same size as other text
document.addEventListener('DOMContentLoaded', function() {
    $('.product-detail .product-name').each(function(index, element) {
        var modifiedText = $(element).text().replace(/\d+/g, '<span class="number">$&</span>');
        element.innerHTML = modifiedText;
    });
});

module.exports = base;
